import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import ForgotPasswordMain from "./forgotPassword";
import AuthLayout1 from "../../layout/AuthLayout/authLayout1";
import { VscLock } from "react-icons/vsc";
import { TbUsers } from "react-icons/tb";
import { TbUserCheck } from "react-icons/tb";
import BANK_LOGO from "client/assets/LOGO/BANK_LOGO.png";
import PerfectScrollbar from "react-perfect-scrollbar";
import { act } from "react";
import ForgotUserNameMain from "./forgotUsername";
import SelfUnlockMain from "./selfUnlock";
export function FailToLogin() {
  const [activeKey, setActiveKey] = useState("ForgotPassword");
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);
  const [data, setData] = useState({});
  const location = useLocation();

  useEffect(() => {
    if (location.state) {
      setActiveKey(location.state);
    } else {
      setActiveKey("ForgotPassword");
    }
  }, []);

  // function renderForm() {
  //   return (
  //     <div className="">
  //       <div>
  //         <div className="row tab-navbar">
  //           {FEATURE_CONFIG.LOGIN_SCREEN.FORGOT_PASSWORD && (
  //             <div
  //               className={
  //                 activeKey === "ForgotPassword" ? "col-4 select" : "col-4"
  //               }
  //             >
  //               <span
  //                 onClick={() => {
  //                   setActiveKey("ForgotPassword");
  //                   setCurrentStep(0);
  //                 }}
  //               >
  //                 {t("pages.login.forgot_password", {
  //                   defaultValue: "Forgot Password",
  //                 })}
  //               </span>
  //             </div>
  //           )}
  //           {FEATURE_CONFIG.LOGIN_SCREEN.FORGOT_USERNAME && (
  //             <div
  //               className={
  //                 activeKey === "ForgotUserName" ? "col-4 select" : "col-4"
  //               }
  //             >
  //               <span
  //                 onClick={() => {
  //                   setActiveKey("ForgotUserName");
  //                   setCurrentStep(0);
  //                 }}
  //               >
  //                 {t("pages.login.forgot_username", {
  //                   defaultValue: "Forgot Username",
  //                 })}
  //               </span>
  //             </div>
  //           )}
  //           {FEATURE_CONFIG.LOGIN_SCREEN.SELF_UNLOCK && (
  //             <div
  //               className={
  //                 activeKey === "SelfUnlock" ? "col-4 select" : "col-4"
  //               }
  //             >
  //               <span
  //                 onClick={() => {
  //                   setActiveKey("SelfUnlock");
  //                   setCurrentStep(0);
  //                 }}
  //               >
  //                 {t("pages.login.self_unlock", {
  //                   defaultValue: "Self Unlock",
  //                 })}
  //               </span>
  //             </div>
  //           )}
  //         </div>
  //         <div className="application-card">
  //           <div className="row">
  //             {activeKey === "ForgotPassword" && (
  //               <ForgotPasswordMain
  //                 currentStep={currentStep}
  //                 setCurrentStep={setCurrentStep}
  //                 data={data}
  //                 setData={setData}
  //               />
  //             )}
  //             {activeKey === "ForgotUserName" && (
  //               <ForgotUserNameMain
  //                 currentStep={currentStep}
  //                 setCurrentStep={setCurrentStep}
  //                 data={data}
  //                 setData={setData}
  //               />
  //             )}
  //             {activeKey === "SelfUnlock" && (
  //               <SelfUnlockMain
  //                 currentStep={currentStep}
  //                 setCurrentStep={setCurrentStep}
  //                 data={data}
  //                 setData={setData}
  //               />
  //             )}
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <>
      <AuthLayout1 module="ForgotPassword" title="Fail To Login">
        <div className="auth-card">
          <PerfectScrollbar>
            <div className="p-4 login-card-padding">
              <img src={BANK_LOGO} height={50} className="mb-3" />
              <h4>Account Recovery Options</h4>

              <div className="recovery-options">
                <div
                  onClick={() => setActiveKey("ForgotPassword")}
                  className={
                    activeKey === "ForgotPassword"
                      ? "selectedOption"
                      : "notSelectedOption "
                  }
                >
                  <div className="login-faibutton">
                    {" "}
                    <VscLock size={18} />
                    <span> Forgot Password</span>
                  </div>
                </div>

                <div
                  onClick={() => setActiveKey("ForgotUserName")}
                  className={
                    activeKey === "ForgotUserName"
                      ? "selectedOption "
                      : "notSelectedOption "
                  }
                >
                  <div className="login-faibutton">
                    <TbUserCheck size={18} />
                    <span>Forgot Username</span>
                  </div>
                </div>

                <div
                  onClick={() => setActiveKey("SelfUnlock")}
                  className={
                    activeKey === "SelfUnlock"
                      ? "selectedOption "
                      : "notSelectedOption "
                  }
                >
                  <div className="login-faibutton">
                    {" "}
                    <TbUsers size={18} />
                    <span>Self Unlock</span>
                  </div>
                </div>
              </div>
              {activeKey === "ForgotPassword" && (
                <ForgotPasswordMain
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                  data={data}
                  setData={setData}
                />
              )}
              {activeKey === "ForgotUserName" && (
                <ForgotUserNameMain
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                  data={data}
                  setData={setData}
                />
              )}
              {activeKey === "SelfUnlock" && (
                <SelfUnlockMain
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                  data={data}
                  setData={setData}
                />
              )}
            </div>
          </PerfectScrollbar>
        </div>
      </AuthLayout1>
    </>
  );
}
